import { type LegalContent } from "@/design-system/Atoms/Modal/modal.types";
import { PrivacyPolicyTemplate } from "@/design-system/Templates";
import { TermsAndConditionTemplate } from "@/design-system/Templates";

export const PRIVACY_POLICY_CONTENT: LegalContent = {
  title: 'Privacy Policy',
  lastUpdated: 'March 13th, 2019',
  content: () => <PrivacyPolicyTemplate />,
};

export const TERMS_OF_SERVICE_CONTENT: LegalContent = {
  title: 'Terms of Service',
  lastUpdated: 'March 13th, 2019',
  content: () => <TermsAndConditionTemplate />,
};


